import React from "react";
import { Typography, Layout, Divider, Image } from "antd";

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

function PrivacyPolicy ()  {
  return (
    <Layout
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #ece9e6, #ffffff)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Content
        style={{
          maxWidth: "900px",
          background: "#fff",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <Image
            preview={false}
            src="./assets/logo2.jpg"
            height={120}
            style={{ borderRadius: "12px", cursor: "pointer" }}
          />
        </div>
        <Typography>
          <Title level={2} style={{ textAlign: "center", marginBottom: "10px" }}>
            Privacy Policy
          </Title>
          <Divider />
          <Paragraph>
            PT. Bolde Inovasi Global ("we") are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect the information you provide when using the <Text strong>Bolde Access</Text> application. By using this app, you agree to this policy.
          </Paragraph>
          <Divider />
          <Title level={3} style={{ color: "#00315c" }}>
            1. Information We Collect
          </Title>
          <Paragraph>We may collect the following information:</Paragraph>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>
              <Text strong>Personal Information:</Text> Name, email, phone number, job title, location, and employee ID provided by the company.
            </li>
            <li>
              <Text strong>Attendance Information:</Text> Location data during check-in/out, check-in and check-out times, and attendance status.
            </li>
            <li>
              <Text strong>Submission Information:</Text> Details of employee submissions such as reason, date, and supporting documents (if any).
            </li>
            <li>
              <Text strong>Device Information:</Text> IP address, device type, operating system, and application activity logs.
            </li>
          </ul>
          <Divider />
          <Title level={3} style={{ color: "#00315c" }}>
            2. How We Use Information
          </Title>
          <Paragraph>The information we collect is used to:</Paragraph>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>Accurately record employee attendance.</li>
            <li>Process and manage employee submissions such as leave or permission requests.</li>
            <li>Comply with legal obligations and company policies.</li>
            <li>Improve application services and provide a better user experience.</li>
          </ul>
          <Divider />
          <Title level={3} style={{ color: "#00315c" }}>
            3. Information Protection
          </Title>
          <Paragraph>
            We are committed to safeguarding your information by:
          </Paragraph>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>Encrypting sensitive data during transmission.</li>
            <li>Limiting access to authorized personnel only.</li>
            <li>Conducting regular audits of our security systems.</li>
          </ul>
          <Paragraph>
            However, please note that no method of data transmission over the Internet or electronic storage is completely secure. We will promptly notify you in the event of a data breach.
          </Paragraph>
          <Divider />
          <Title level={3} style={{ color: "#00315c" }}>
            4. Sharing Information with Third Parties
          </Title>
          <Paragraph>
            We do not sell or rent your personal information. We only share it under the following circumstances:
          </Paragraph>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>
              <Text strong>Service Providers:</Text> We may collaborate with third-party providers to support application operations, such as cloud service providers.
            </li>
            <li>
              <Text strong>Legal Obligations:</Text> When required by law or court order.
            </li>
          </ul>
          <Divider />
          <Title level={3} style={{ color: "#00315c" }}>
            5. Data Retention
          </Title>
          <Paragraph>
            We retain your data for as long as necessary to fulfill the purposes of use, unless longer retention is required by law.
          </Paragraph>
          <Divider />
          <Title level={3} style={{ color: "#00315c" }}>
            6. Changes to Privacy Policy
          </Title>
          <Paragraph>
            We may update this Privacy Policy from time to time. Changes will be communicated via the application or registered email. We encourage you to review this policy periodically.
          </Paragraph>
        </Typography>
      </Content>
    </Layout>
  );
};

export default PrivacyPolicy;
